"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _react = _interopRequireWildcard(require("react"));

var EyeIcon = function EyeIcon(props) {
  return _react["default"].createElement("svg", (0, _extends2["default"])({}, props, {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24"
  }), _react["default"].createElement("title", null, props["aria-label"]), _react["default"].createElement("path", {
    fill: "currentColor",
    fillRule: "nonzero",
    d: "M3.94 12.081c1.098 2.478 4.33 4.264 8.089 4.264 3.913 0 7.255-1.936 8.212-4.573a.906.906 0 0 1 1.704.619c-1.24 3.42-5.294 5.767-9.916 5.767-4.622 0-8.676-2.347-9.917-5.767L2 12.08l.112-.309c1.241-3.42 5.295-5.767 9.9-5.767 2.804-.05 4.821.276 6.092 1.034a.906.906 0 0 1-.93 1.557c-.912-.544-2.635-.823-5.145-.778-3.759 0-6.99 1.786-8.088 4.263zm17.176-2.427a1.075 1.075 0 1 1-1.52-1.52 1.075 1.075 0 0 1 1.52 1.52zm-8.634 5.415a3.173 3.173 0 1 1 0-6.345 3.173 3.173 0 0 1 0 6.345z"
  }));
};

EyeIcon.defaultProps = {
  width: "24px",
  height: "24px",
  "aria-label": "Eye Icon",
  color: "#233750"
};
var _default = EyeIcon;
exports["default"] = _default;